<template>
  <ion-page>
    <ion-header>
      <ion-toolbar color="secondary">
        <ion-buttons slot="start">
          <ion-button @click="modalController.dismiss">
            <ion-icon
              slot="icon-only"
              :src="close"
              color="primary"
            />
          </ion-button>
        </ion-buttons>
        <ion-title>
          {{ $t('cars.add_car') }}
        </ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content :scroll-y="false">
      <div class="content">
        <div class="ion-padding">
          <p>{{ $t('cars.add_description') }}</p>

          <ion-input
            v-model="license"
            placeholder="A-123-BC"
            required
            class="ion-margin-top"
          />

          <ion-button
            class="ion-margin-top-sm"
            expand="block"
            color="light"
            @click="search()"
          >
            {{ $t('general.search') }}
          </ion-button>

          <template v-if="result && !result.brand">
            <p class="ion-margin-top-lg">
              {{ $t('cars.add_no_results') }}
            </p>
          </template>
          <template v-else-if="result">
            <h2 class="ion-margin-top-lg">
              {{ $t('general.search_heading') }}
            </h2>

            <ion-item
              button
              lines="none"
              class="ion-margin-top-sm"
            >
              <ion-thumbnail
                slot="start"
                class="vehicle"
              >
                <car-logo :vehicle="result" />
              </ion-thumbnail>
              <ion-label>
                <h3> {{ result.brand }} {{ result.model }}</h3>
                <h2>
                  {{ result.identifiers.find(i => i.type === 'license_plate')?.value ?? null }}
                </h2>
              </ion-label>
            </ion-item>
          </template>
          <template v-if="result">
            <ion-button
              class="ion-margin-top-sm"
              expand="block"
              color="primary"
              @click="add()"
            >
              {{ $t('general.add') }}
            </ion-button>
          </template>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue';
import {
  IonButtons,
  IonInput,
  modalController,
} from '@ionic/vue';
import {
  close,
} from 'ionicons/icons';
import CarLogo from '@/components/CarLogo.vue';
import ErrorMixin from '@/mixins/ErrorMixin';
import VehicleService from '@/services/Vehicle';

export default defineComponent({
  components: {
    IonButtons,
    IonInput,
    CarLogo,
  },
  mixins: [ErrorMixin],
  setup() {
    return {
      modalController,
      close,
    };
  },
  data() {
    return {
      license: '',
      result: null,
    };
  },
  methods: {
    /**
     * Search by license plate.
     */
    async search() {
      await this.handleErrors(async () => {
        this.result = await VehicleService.info(this.license);
      });
    },
    /**
     * Add vehicle.
     */
    async add() {
      await this.handleErrors(async () => {
        await VehicleService.add(this.license);
        modalController.dismiss();
      });
    },
  },
});
</script>

<style scoped>
ion-input {
  background: var(--ion-color-plate);
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
}

ion-item {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  font-size: 16px;

  --background: var(--ion-color-light);

  ion-thumbnail.vehicle {
    width: 81px;
    height: 80px;
    margin: 0 20px 0 -16px;
    padding: 10px;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }

  ion-label {
    h3 {
      font-size: 14px;
      font-weight: 500;
    }

    h2 {
      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0;
    }
  }
}
</style>
